import { InlineAnimatedSvg } from './inline-animated-svg'
import type { CfImage } from '~/types/contentful'
import { contentfulImage } from '~/utils/contentful-image'

interface CfMediaProps {
  media?: CfImage
  className?: string
  imageWidth?: number
}

export function CfMedia({ media, className, imageWidth = 1600 }: CfMediaProps) {
  const url = media?.fields?.file?.url
  const alt = media?.fields?.title ?? ''

  if (!url) {
    return null
  }

  if (media?.fields?.file?.contentType?.startsWith('video/')) {
    return (
      <video
        className={className}
        src={url}
        autoPlay
        muted
        loop
        playsInline
        aria-label={alt || undefined}
      />
    )
  }

  const img = (
    <img
      className={className}
      src={contentfulImage(url, { w: imageWidth })}
      alt={alt}
    />
  )

  // Animated marketing diagrams must render inline (Chrome freezes CSS
  // animations in SVG-as-<img>). Non-animated SVGs keep the <img> above
  // unchanged — InlineAnimatedSvg only swaps in files carrying the anim-svg
  // marker.
  if (media?.fields?.file?.contentType === 'image/svg+xml') {
    const rawUrl = contentfulImage(url)
    if (rawUrl) {
      return (
        <InlineAnimatedSvg
          svgUrl={rawUrl}
          fallback={img}
          className={className}
          accessibleName={alt}
        />
      )
    }
  }

  return img
}
